<template>
  <div class="pages">
    <el-tabs v-model="activeName" type="card">
      <div class="filter">
        <div>
          <el-form size="small" :inline="true">
            <el-form-item label="状态">
              <el-select v-model="formInline.state">
                <el-option
                  :label="v.name"
                  :value="v.value"
                  v-for="(v, i) in stateList"
                  :key="i"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="选择日期">
              <el-date-picker
                v-model="formInline.dateValue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="学校" v-if="$store.state.userinfo.isSuper">
              <el-select
                clearable
                v-model="formInline.School"
                placeholder="请选择学校"
              >
                <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="search">
          <el-form size="small" :inline="true">
            <el-form-item label="关键字">
              <el-input
                v-model="formInline.keyWord"
                placeholder="请输入关键词查询"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchList">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-tabs>

    <div class="table">
      <div v-show="activeName == 0">
        <el-button type="primary" size="medium" @click="allResolve"
          >批量解决</el-button
        >
        <el-button type="danger" size="medium" @click="addDel"
          >批量删除</el-button
        >
        <el-table
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :data="tableData"
          height="5.32rem"
          max-height="5.32rem"
        >
          <el-table-column type="selection" align="center" width="50">
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="userName"
            label="用户名"
            align="center"
          >
          </el-table-column>
          <el-table-column
            v-if="$store.state.userinfo.isSuper"
            show-overflow-tooltip
            property="schoolName"
            label="所属学校"
            align="center"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="name"
            label="真实姓名"
            align="center"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="content"
            label="意见内容"
            align="center"
          >
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            property="creationTime"
            label="反馈时间"
            align="center"
          >
          </el-table-column>
          <el-table-column property="state" label="状态" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.state === 0" style="color: #999999">未解决</p>
              <p v-else-if="scope.row.state === 1" style="color: #198cff">
                已解决
              </p>
              <p v-else style="color: #ea2727; font-weight: bold">异常</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button @click="see(scope.row)" type="text" size="medium"
                >详情</el-button
              >
              <el-button
                v-if="scope.row.state === 1"
                @click="handleClick(scope.row)"
                type="text"
                style="color: #2ee12e"
                size="medium"
                >已解决</el-button
              >
              <el-button
                v-if="scope.row.state === 0"
                @click="resolve(scope.row)"
                type="text"
                size="medium"
                >解决</el-button
              >
              <el-button
                @click="del(scope.row)"
                style="color: #f00"
                type="text"
                size="medium"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- <div v-show="activeName == 1">
        <el-table :data="tableData" height="5.28rem" max-height="5.28rem">
          <el-table-column type="index" label="序号" align="center">
          </el-table-column>
          <el-table-column property="date" label="用户名" align="center">
          </el-table-column>
          <el-table-column property="name" label="真实姓名" align="center">
          </el-table-column>
          <el-table-column property="name" label="意见内容" align="center">
          </el-table-column>
          <el-table-column property="time" label="反馈时间" align="center">
          </el-table-column>
          <el-table-column property="state" label="认证状态" align="center">
            <template slot-scope="scope">
              <p v-if="scope.row.state === 3" style="color: #2ee12e">已解决</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                @click="centerDialogVisible = true"
                type="text"
                size="medium"
                >详情</el-button
              >
              <el-button
                @click="del(scope.row)"
                style="color: #f00"
                type="text"
                size="medium"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div> -->
      <div class="pages justify-end">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="currentSize"
          layout="  prev, pager, next,  sizes, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      v-if="JSON.stringify(currfeedInfo) != '{}'"
      title="查看"
      :visible.sync="centerDialogVisible"
      :destroy-on-close="true"
      width="30%"
    >
      <el-row class="detail">
        <el-col :span="12">用户名：{{ currfeedInfo.userName }} </el-col>
        <el-col :span="12">反馈时间：{{ currfeedInfo.creationTime }} </el-col>
        <el-col :span="12">真实姓名：{{ currfeedInfo.name }} </el-col>
        <el-col :span="12">联系方式：{{ currfeedInfo.contactPhone }} </el-col>
        <el-col v-if="$store.state.userinfo.isSuper" :span="12"
          >所属学校：{{ currfeedInfo.school }}
        </el-col>
      </el-row>
      <el-row
        class="inner"
        style="border: 1px solid #ccc; border-radius: 4px; padding: 10px"
      >
        <span>{{ currfeedInfo.content }} </span>
        <el-image
          v-for="(v, i) in currfeedInfo.image.split(',')"
          :key="i"
          style="width: 100px; height: 100px"
          :src="apiUrl + v"
          fit="cover"
          :preview-src-list="[apiUrl + v]"
        >
        </el-image>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      schoolList: [],
      activeName: 0,
      centerDialogVisible: false,
      tableData: [],
      formInline: {
        School: "",
        dateValue: [],
        keyWord: "",
        state: ""
      },
      //翻页
      currentPage: 1,
      currentSize: 10,
      totalCount: 0,
      //选中意见反馈信息
      currfeedInfo: {},
      multipleSelection: [],
      ids: [],
      apiUrl: "",
      //角色列表
      stateList: [
        { name: "全部", value: "" },
        { name: "未解决", value: 0 },
        { name: "已解决", value: 1 }
      ]
    };
  },
  created() {
    this.getFeedbackList();
    this.getSchoolList();
    this.apiUrl = window.api.apiurl;
  },
  methods: {
    //获取学校
    getSchoolList(pageIndex = 1, pageSize = 9999999) {
      var params = {
        PageIndex: pageIndex,
        PageSize: pageSize
      };

      var url = this.$dataConver.getUrl("/admin/School/GetSchoolList", params);

      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.schoolList = res.data.items;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    searchList() {
      this.currentPage = 1;
      this.getFeedbackList(this.currentPage);
    },
    //获取列表信息
    getFeedbackList(PageIndex = 1, PageSize = 10) {
      var params = {
        schoolId: this.formInline.School ? this.formInline.School : null,
        Keyword: this.formInline.keyWord,
        state: this.formInline.state,
        PageIndex: PageIndex,
        PageSize: PageSize,
        DateBegin:
          this.formInline.dateValue == null ? "" : this.formInline.dateValue[0],
        DateEnd:
          this.formInline.dateValue == null ? "" : this.formInline.dateValue[1]
      };
      var url = this.$dataConver.getUrl(
        "/admin/Feedback/GetFeedbackList",
        params
      );
      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.tableData = res.data.items;
          this.totalCount = res.data.total;
          if (this.tableData.length <= 0 && this.currentPage > 1) {
            this.getFeedbackList(--this.currentPage);
          }
        } else {
          this.$message.error(res.error);
        }
      });
    },
    see(val) {
      console.log(val);
      this.centerDialogVisible = true;
      this.currfeedInfo = val;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection);
      this.ids = [];
      this.multipleSelection.forEach(element => {
        this.ids.push(element.id);
      });
      console.log(this.ids);
    },
    //批量解决
    allResolve() {
      if (this.ids.length <= 0) {
        this.$message.error("请选择至少一条信息！");
        return false;
      }
      this.$confirm("确认解决?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.resolveFeed(this.ids);
        })
        .catch(() => {});
    },
    //批量删除
    addDel(val) {
      if (this.ids.length <= 0) {
        this.$message.error("请选择至少一条信息！");
        return false;
      }
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteFeed(this.ids);
        })
        .catch(() => {});
    },
    resolve(val) {
      this.$confirm("确认解决?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.resolveFeed([val.id]);
        })
        .catch(() => {});
    },
    del(val) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deleteFeed([val.id]);
        })
        .catch(() => {});
    },
    //解决反馈
    resolveFeed(ids) {
      this.$api.post("/admin/Feedback/SolveFeedback", ids).then(res => {
        if (res.succeed) {
          this.$message.success("操作成功！");
          this.getFeedbackList();
        } else {
          this.$message.error(res.error);
        }
      });
    },
    //删除反馈
    deleteFeed(ids) {
      this.$api.post("/admin/Feedback/DeleteFeedback", ids).then(res => {
        if (res.succeed) {
          this.$message.success("操作成功！");
          this.getFeedbackList();
        } else {
          this.$message.error(res.error);
        }
      });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.currentSize = val;
      this.getFeedbackList(1, this.currentSize);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getFeedbackList(this.currentPage, this.currentSize);
    }
  }
};
</script>
<style lang="scss" scoped>
.table {
  margin-top: 0.2rem;
  padding: 0.24rem 0.19rem 0.3rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
}
.filter {
  padding: 0.25rem 0.19rem 0.23rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
  display: flex;
  justify-content: space-between;
  >>> .el-form-item {
    margin-bottom: 0;
  }
}
.section {
  padding: 0.23rem 0.18rem 0.57rem;
  flex: 1 1 2.4rem;
  border-radius: 0.06rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 1.4rem;
  .name {
    color: rgb(102, 102, 102);
    font-size: 0.18rem;
    font-family: Microsoft YaHei;
    line-height: 0.17rem;
  }
  .number {
    margin-top: 0.17rem;
    color: rgb(51, 51, 51);
    font-size: 0.32rem;
    font-family: Microsoft YaHei;
    line-height: 0.26rem;
  }
}
.detail {
  line-height: 3;
}
.inner >>> textarea {
  height: 1rem;
  resize: none;
}
.inner span{
  vertical-align: top
}
</style>



// WEBPACK FOOTER //
// src/view/feedback.vue